import React, {Component, useState,useEffect, useMemo} from 'react';
import {useHomeBlog} from '../../queries/homeBlog';
import SelectedProductItem from './SelectedProductItem';
import SectionTitle from '../../components/UI/SectionTitle/index';
import { useRandomSelectedHVProducts } from '../../queries/randomHVproducts';
import axios from 'axios';
import {PRODUCT_SEARCH} from './../../queries/productSearch';
import {useLazyQuery, gql} from "@apollo/client";
import InfinitProgressBar from '../../components/InfiniteProgressBar';

function randomIntFromInterval(min, max) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

function SelectedHVProducts({title}) {    
    const products = [];
    const d = useRandomSelectedHVProducts();
    if(d.loading) return 
    <InfinitProgressBar/>
    if(d.error) return <div>error!</div>
    if (!d.data) {
        return;
    }
    d.data.randomProductsSQL.map(x => {
        products.push(x);
    });
   
    
    return (
        <div className="blog-area-wrapper sm-top">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <div style={{width:'10%', height:"5px", backgroundColor:'red', margin:"auto" }}/><br/>
                        <SectionTitle title=" " heading={title}  txtcolor="#000"/>
                    </div>
                </div>
                <br/>
                <br/>

                <div className="row mtn-35">
                    {
                        products.map((HV,j) =>(
                            <SelectedProductItem key={j} alias={HV.displayText} productId={HV.contentItemId} img={process.env.REACT_APP_BASE_URL+"/media/Poducts/" + HV.displayText + ".jpg"} title={HV.displayText} excerpt={""}/>
                        )) 
                    }
                </div>
            </div>
        </div>
    );
}

export default SelectedHVProducts;
